module.exports = __webpack_public_path__ + "static/media/cert_part3_evo.d72b36dc.png";